import React from 'react';
import { useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Typography } from '@material-ui/core';
import AppState from '../../../models/redux/state/app.state';

const Alert = (): JSX.Element => {
  const severity = useSelector((state: AppState) => state.alert.severity);
  const message = useSelector((state: AppState) => state.alert.message);
  return (
    <Snackbar open={severity !== undefined}>
      {severity ? (
        <MuiAlert elevation={6} severity={severity}>
          <Typography variant="caption">{message}</Typography>
        </MuiAlert>
      ) : undefined}
    </Snackbar>
  );
};

export default Alert;
